/**
 * Determines whether the `value` is `undefined`.
 */
const isUndefined = value => {
  return value === undefined;
};

export { isUndefined as i };
